import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OnPagingFiltersChangeService {
    private subject = new Subject<any>();

    ChangeValue(value: string) {
        this.subject.next(value);
    }

    ClearValue() {
        this.subject.next();
    }

    GetValue(): Observable<any> {
        return this.subject.asObservable();
    }
}